import CLPViewState from '../store/schema/CLPViewState';
import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';
import ItemId from 'owa-service/lib/contract/ItemId';
import getExistingCLPInfo from './getExistingCLPInfo';
import getDefaultClPLabel from './getDefaultCLPLabel';

export default function createCLPViewState(
    labelString: string,
    referenceItemId: ItemId
): CLPViewState {
    let existingCLPInfo: { nonTenantLabelString: string; selectedLabel: CLPLabel } = null;
    existingCLPInfo = getExistingCLPInfo(labelString);
    if ((labelString && !existingCLPInfo.selectedLabel) || (!labelString && !referenceItemId)) {
        existingCLPInfo.selectedLabel = getDefaultClPLabel();
    }

    let autoLabelViewState = {
        inProgressAutoLabelRequest: null,
        pendingAutoLabelRequest: null,
        automatic: null,
        recommended: null,
        contentOfExistingAutoLabel: '',
        shouldKeepGettingAutoLabel: true,
    };

    return {
        justificationSent: false,
        originalCLPLabel:
            existingCLPInfo && existingCLPInfo.selectedLabel ? existingCLPInfo.selectedLabel : null,
        selectedCLPLabel:
            existingCLPInfo && existingCLPInfo.selectedLabel ? existingCLPInfo.selectedLabel : null,
        nonTenantLabelString:
            existingCLPInfo && existingCLPInfo.nonTenantLabelString
                ? existingCLPInfo.nonTenantLabelString
                : '',
        autoLabelViewState,
    };
}
